<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '460px' }"
    >
    <!-- 表单 -->
    <div >
      <div class="bagrcos">
        <!-- 左侧树 -->
        <div style="overflow-y: scroll;width: 200px;">
            <a-tree v-if="treeData.length > 0" :tree-data="treeData" :defaultExpandAll="true"
                @select="(a, b) => selectNode(a, b)" :selectedKeys="selectedKeys">
            </a-tree>
        </div>
        <div class="add_form" style="display: flex;flex-direction: column;margin-left: 30px;width: 400px;">
          <!-- 已选标签 -->
          <span style="font-size: 14px;">已选标签:</span>
          <div style="flex: 1;overflow-y: scroll;border: 1.5px solid #e4e4e4;display: flex;
    padding: 5px;flex-wrap: wrap;">
            <div v-for="(item, index) in this.getList" :key="index">
              <a-button style="margin-right: 15px;height: 25px;margin-bottom: 10px;" :class="item.checked === true ? 'changePri' : 'primary'"  @click="btnChange(item,index)">{{ item.labelName }}</a-button>
            </div>
          </div>
          <!-- 未选标签 -->
          <div style="flex: 4;margin-top: 20px;">
            <!-- 单选框 -->
            <div v-if="this.labelType == '0'">
              <a-table
                :row-selection="{ type: 'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange , columnWidth: '20px'}"
                class="antd-table"
                bordered
                :columns="relevanceBatch_grid.field"
                :data-source="relevanceBatch_grid.row"
                rowKey="id"
                size="small"
                :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
                :pagination="false"
              >
                  <!-- 序号 -->
                  <span slot="index" slot-scope="text, record, index">
                    {{index + 1}}
                  </span>
              </a-table>
            </div>
            <!-- 多选框 -->
            <div v-else>
              <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange , columnWidth: '20px'}"
                class="antd-table"
                bordered
                :columns="relevanceBatch_grid.field"
                :data-source="relevanceBatch_grid.row"
                rowKey="id"
                size="small"
                :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
                :pagination="false"
              >
                  <!-- 序号 -->
                  <span slot="index" slot-scope="text, record, index">
                    {{index + 1}}
                  </span>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="cancel-color" ghost @click="handleCancel">取消</a-button>
      <a-button  class="btn-color" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import{ addRecLabel,labelList, labelQuery } from "@/api/api.js";
import upload from "@/components/upload/upload.vue";
export default {
  components: { upload },
  props: {
    modalTitle: {
      type: String,
      default: () => "客户标签",
    }, //标题
    recId: {
      type: String,
      default: () => "",
    },//服务id
    labelListQuery: {
      type: Array,
      default: () => [],
    },//标签
    // data: {
    //   type: Object,
    //   default: () => [],
    // },//返回信息
  },
  data() {
    return {
      imgUrl:"",
      visible: true,
      okLoad:false,
      treeData: [],
      menuData: [],
      selectedKeys: ['1'], //默认选中节点
      getList: [],
      butVisible: true,
      labelType:'',  //选择类型

      relevanceBatch_grid: {
        height: "260px",
        width: 0, // 宽度
        row: [
        ],
        field: [
          {
            title: "序号",
            align: "center",
            width: 30,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "标签名称",
            align: "center",
            width: 150,
            dataIndex: "labelName",
            ellipsis: true,
          },
        ]
      },
      selectedRows: [],//多选数据
      selectedRowKeys: [],
    }
  },
  mounted() {
    // console.log("recIdrecIdrecId",this.recId)
    if (this.labelListQuery.length > 0) {
      this.labelListQuery.forEach(item => {
        this.getList.push({
          entityId: item.typeId,
          labelName: item.labelName,
          checked: true,
          id:item.id,
        })
      })
    }
    // 获取列表数据
    this.searchList()
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    // 配置最近几小时按钮颜色
    btnChange(data,index) {
      this.butVisible = false;
      this.getList.splice(index, 1);
      // const indexl = this.getList.findIndex((item) => item.entityId === data.entityId)
      this.selectedRowKeys.splice(index,1)
      this.butVisible = true;
    },

    onSelectChange(data, selectedRows) {
      this.selectedRows = selectedRows;
      //单选
      if (this.labelType == '0') {
        //筛选------去除之前的，保留当前这一个
        //查找当前为这个值的元素下标
        const index = this.getList.findIndex((item) => item.entityId === this.selectedRows[0].entityId)
        if (index > -1) {
          this.selectedRowKeys.splice(this.getList[index].id, 1);
          this.selectedRowKeys =this.selectedRowKeys.filter(item => {
            return item !== this.getList[index].id;
          });
          this.getList.splice(index, 1);
        }

        //放值
        this.selectedRowKeys.push(data[0]);
      } else {
        this.selectedRowKeys = data;
      }

      this.selectedRows.forEach(item => {
        this.getList.push({
          entityId: item.entityId,
          labelName: item.labelName,
          checked: true,
          id:item.id,
        })
      })

      //删除不存在的元素
      this.getList = this.selectedRowKeys.map(item1 => { return this.getList.find(item2 => item2.id === item1);});

      //去重
      this.getList = [...new Set(this.getList.map(item => item.id))].map(id => this.getList.find(item => item.id === id));
    },

    // 菜单列表查询
    searchList() {
      labelList({}).then((res) => {
          // if (res.content[0]) {
          //     res.content.map(item => {
          //         let str = item.typeName + ':' + item.choiceType == '1' ? '是' : item.choiceType == '0' ? '否' : '' + '(' + item.labelCount + ')'
          //         this.labelLists.push({ 'label': str, 'value': item.id })
          //     })
          // }
          this.menuData = res.content
          this.getTreemenu(res.content, 0)
          //this.getTree(res.content, 0)
      }).then((res) => {
          //this.traverse(this.menuIddata)
      })
      },

    // 树型菜单列表获取
    getTreemenu(data, parentId) {
        var treeMenu = [];
        var streeMenu = [];
        for (var i = 0; i < data.length; i++) {
            var node = data[i]

            let type = +node.choiceType == '1' ? '多选' : '单选'
            let str = '(' + node.labelCount + ')'

            if (data[i].parentId == parentId) {
                var newTree = {
                    key: node.id,
                    title: node.typeName + ' ：' + type + str,
                    mlink: node.menuLink,
                    choiceType: node.choiceType,
                    children: this.getTreemenu(data, node.id)
                };

                treeMenu.push(newTree)

            }
        }
        this.treeData = treeMenu
        return treeMenu
    },
    // 树型下拉菜单列表获取
    getTree(data, parentId, updateId) {
        var streeMenu = [];
        for (var i = 0; i < data.length; i++) {
            var node = data[i];
            if (data[i].parentId == parentId) {
                var newTree = {
                    key: node.id,
                    title: node.typeName,
                    value: node.id,
                    parentid: node.parentId,
                    children: this.getTree(data, node.id),
                };
                streeMenu.push(newTree);
            }
        }
        this.menuIddata = streeMenu;
        return streeMenu;
    },

    // 左键单机树节点
    selectNode(key, e) {
      let keys = [e.node.eventKey];
      this.selectedKeys.splice(0)
      this.selectedKeys = keys
      labelQuery({ content: { entityId: e.node.eventKey,enable:'1', } }).then(
        (res) => {
          this.selectedRowKeys = [];
          this.labelType = e?.selectedNodes[0]?.data?.props?.choiceType;

          //返显按钮
          this.getList.forEach(item => {
            this.selectedRowKeys.push(item.id);
          })
          this.relevanceBatch_grid.row = res.content.rows;
          },
          (err) => {
              this.$message.error('查询失败')
          })
  },

    // //监听附件组件
    // listen(val) {
    //   this.uploadAgain = false;
    //   if(val.length == 0){
    //     this.imgUrl = false;
    //     this.imgUrls =[];
    //   }else if(val.length < 3){
    //     this.imgUrl = true;
    //     this.imgId = val[0].id;
    //     this.imgUrls.push(val[0].id);
    //     this.uploadAgain = false;//监听是否已上传要求数量以内的文件
    //   }else {
    //     this.imgUrl = true;
    //     this.imgId = val[0].id;
    //     this.imgUrls.push(val[0].id);
    //     this.uploadAgain = true;//监听是否已上传要求数量以内的文件
    //   }
    //   this.fileNum = val.length;
    // },

    // //添加事件
    handleOk() {
      //校验图片
      if (this.getList.length > 0) {
        let params = {
          labelList: [],
          recId:'',
        };
        this.getList.forEach(item => {
          params.labelList.push({
            labelId: item.id,
            typeId: item.entityId,
          })
        })
        params.recId = this.recId;
        addRecLabel(params).then(
        (res) => {
            this.$message.success('操作成功');
            this.$emit('handleOk');
          
        },
        (err) => {
            this.$message.error(err.message || '查询失败')
            //this.Tableloading = false
        })
        
      } else {
        return this.$message.warning("请选择标签！")
      }
    },
  },
}
</script>

<style scoped>
.btn-color {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}
.cancel-color{
  border-color: rgba(22, 130, 139, 1);
  color: rgba(22, 130, 139, 1);
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}

.bagrcos {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 420px;
    margin-top: 10px;
    .add_form {
        flex: 1;
        h2 {
            font-size: medium;
        }
        margin-left:30px;
    }
}

.changePri {
  background: #16828b;
  border-color: #16828b;
  color: white;
}

</style>
